import Employee from "./employee"
import Opportunity from "./opportunity"
import { Queryable } from "./queryable"

export interface IndustryEngagementStatus {
    id: string
    description: string
}

export interface IndustryEngagementAttendee {
    engagementId: string
    employeeId: string
    engagement?: IndustryEngagement
    employee?: Employee
}

export interface IndustryEngagement {
    id: string
    name: string
    date?: Date | null
    description?: string | null
    statusId: string
    createdById: string
    updatedById?: string | null
    deletedAt?: Date | null
    deletedById?: string | null
    createdAt?: Date
    updatedAt?: Date

    status?: IndustryEngagementStatus
    attendees?: IndustryEngagementAttendee[]
    opportunities?: Opportunity[]
    createdBy?: Employee
    updatedBy?: Employee
    deletedBy?: Employee
}

export interface IIndustryEngagementQueryParams extends Queryable {
    name?: string;
    statusIds?: string[];
    attendeeIds?: string[];
    opportunityIds?: string[];
    dateFrom?: string;
    dateTo?: string;
}


export class IndustryEngagementUI {
    static readonly COMPLETE_STATUS = 'Complete'
    static readonly PENDING_STATUS = 'Pending'
    static readonly REGISTERED_STATUS = 'Registered'
    static readonly IN_PROGRESS_STATUS = 'In Progress'
    static readonly PLANNED_STATUS = 'Planned'

    static statusColor(status?: string): string {
        if (!status) return ''

        if (status === this.COMPLETE_STATUS)
            return 'success'

        if (status === this.PENDING_STATUS)
            return 'warning'

        if (status === this.REGISTERED_STATUS)
            return 'active'

        if (status === this.IN_PROGRESS_STATUS)
            return 'pending'

        if (status === this.PLANNED_STATUS)
            return 'pending'

        return ''
    }
}